import React from 'react';

/**
 * Checkmark Icon Component
 *
 * A green circular checkmark icon used to indicate success or completion
 * Used in the Credit App Summary to show successful submission
 */
export const CheckmarkIcon: React.FC = () => {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="32" cy="32" r="32" fill="#21b500" />
            <path d="M20 33L28 41L44 25" stroke="white" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
